
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M15.398 1.25a3.337 3.337 0 012.377.973l-.529.531.532-.53a3.337 3.337 0 01-.03 4.739L7.442 17.27a.75.75 0 01-.344.196l-4.91 1.26a.75.75 0 01-.913-.913l1.259-4.91a.75.75 0 01.196-.345L13.037 2.252a3.337 3.337 0 012.36-1zm1.318 2.034a1.837 1.837 0 00-2.61.02l-.005.005L3.935 13.475l-.894 3.484 3.484-.894L16.697 5.893a1.836 1.836 0 00.019-2.609z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.745 2.543a.75.75 0 011.06 0l3.651 3.65a.75.75 0 01-1.06 1.061l-3.65-3.65a.75.75 0 010-1.061zm-1.489 1.49a.75.75 0 011.06 0l3.651 3.65a.75.75 0 11-1.06 1.061l-3.651-3.65a.75.75 0 010-1.061zM2.728 12.56a.75.75 0 011.061-.001l3.654 3.647a.75.75 0 11-1.06 1.062L2.73 13.621a.75.75 0 010-1.06z","clip-rule":"evenodd"}})])
          )
        }
      }
    